export default __webpack_public_path__ + "static/media/1128040325514716.5d72b088.jpg";